import config from '@efdigital/ll-admin-v2/config/environment';
import EmberRouter from '@embroider/router';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  // Add route declarations here
  this.route('resource');
  this.route('programs', function () {
    this.route('program', { path: ':program_id' }, function () {
      this.route('cohort', { path: 'cohort/:cohort_id' }, function () {
        this.route('participants');
        this.route('calendar', function () {
          this.route('calendar-item', {
            path: 'calendar-item/:calendar_item_id',
          });
        });
        this.route('messages', function () {
          this.route('category', { path: ':category' }, function () {
            this.route('new');
            this.route('message', { path: ':message_id' });
          });
        });
        this.route('content', function () {
          this.route('module', { path: 'module/:module_id' }, function () {
            this.route('page', { path: 'page/:page_id' });
            this.route('quiz', { path: 'quiz/:quiz_id' });
          });
          this.route('page', { path: 'page/:page_id' });
          this.route('quiz', { path: 'quiz/:quiz_id' });
        });
      });
    });
  });
  this.route('library', function () {
    this.route('clients', function () {
      this.route('client', { path: 'client/:client_id' }, function () {
        this.route('edit', function () {
          this.route('branding');
          this.route('content');
          this.route('files');
          this.route('general');
          this.route('home');
          this.route('users');
          this.route('xapi');
        });
      });
    });
    this.route('media-images', function () {
      this.route('edit', { path: 'edit/:media_image_id' });
      this.route('upload');
    });
    this.route('folders', function () {
      this.route('new', { path: '/new/:parent' });
      this.route('file', { path: '/file/:file_id' });
      this.route('upload');
    });
  });
  this.route('bootstrap');
});
